import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import ConnectionSuccess from '@/components/zoom-diagnostic/ConnectionSuccess.vue'
import ConnectionFailed from '@/components/zoom-diagnostic/ConnectionFailed.vue'
import LoadingBox from '@/components/zoom-diagnostic/Loading.vue'
import { Stage, Topic } from '@/types/enums/zoom-diagnostic.enum'
import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { connectionProgress, connectionFailed } from '@/composables/zoom-diagnostic/useConnection'

interface ConnectivityEmits {
  (e: 'nextStage', value: number): void
  (e: 'inprogress'): void
  (e: 'updateTopic', value: IUpdateTopic): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Connectivity',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "inprogress", "updateTopic"],
  setup(__props, { emit: __emit }) {

const props = __props

const i18n = useI18n()

const emit = __emit

const header = computed(() => i18n.t('zoom-diagnostic.hang-tight'))
const message = computed(() => i18n.t('zoom-diagnostic.hang-tight-detail'))

const inprogress = computed(() => connectionProgress.value)
const failed = computed(() => connectionFailed.value)

watch(inprogress, (value) => {
  if (value === false) {
    emit('inprogress')
  }
})

watch(
  () => props.stage,
  (stage, prevStage) => {
    if (stage === Stage.CONNECTIVITY) {
      emit('updateTopic', { topic: Topic.CONNECTIVITY, active: true })
    }
    if (prevStage === Stage.CONNECTIVITY && stage === Stage.AUDIO_TEST) {
      emit('updateTopic', { topic: Topic.CONNECTIVITY, active: false })
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (inprogress.value)
    ? (_openBlock(), _createBlock(LoadingBox, {
        key: 0,
        stage: __props.stage,
        header: header.value,
        message: message.value
      }, null, 8, ["stage", "header", "message"]))
    : (!failed.value)
      ? (_openBlock(), _createBlock(ConnectionSuccess, {
          key: 1,
          stage: __props.stage,
          onNextStage: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage', _unref(Stage).RESULTS)))
        }, null, 8, ["stage"]))
      : (_openBlock(), _createBlock(ConnectionFailed, {
          key: 2,
          stage: __props.stage,
          onNextStage: _cache[1] || (_cache[1] = ($event: any) => (emit('nextStage', _unref(Stage).RESULTS)))
        }, null, 8, ["stage"]))
}
}

})